import FFHomeHeroBannerUI, {
  Props as UIProps,
} from '@interflora/ui-components/build/components/FFHomeHeroBanner/FFHomeHeroBanner'
import React from 'react'
import { useAnalytics } from 'hooks/useAnalytics'
import { useLoaded } from '@interflora/ui-components/build/components/MainContent/useComponentLoading'

type Props = UIProps

const FFHomeHeroBanner = (props: Props) => {
  const analytics = useAnalytics()

  const homeHeroCTAnalytics = (category: string) => {
    analytics.homeHeroBanner(category)
  }

  useLoaded(props)

  return <FFHomeHeroBannerUI {...props} homeHeroCTAnalytics={homeHeroCTAnalytics} />
}

export default FFHomeHeroBanner
